import { render, staticRenderFns } from "./clipboard-list.vue?vue&type=template&id=a9d93a36"
import script from "./clipboard-list.vue?vue&type=script&lang=js"
export * from "./clipboard-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports